import React from "react";
import { Grid as ChakraGrid, forwardRef, useStyleConfig, } from "@chakra-ui/react";
export const LayoutGrid = forwardRef((props, ref) => {
    const styles = useStyleConfig("LayoutGrid");
    return React.createElement(ChakraGrid, Object.assign({ __css: styles }, props, { ref: ref }));
});
